import { StyleSheet } from 'aphrodite';
import { FontFamilies } from '../../../web/styles/styles';
import { brandPrimary, white } from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	close: {
		marginTop: 3,
	},
	container: {
		...aidaBaseStyles.cardShadow,
		background: white,
		borderRadius: 5,
		bottom: '10vh',
		left: 150,
		position: 'fixed',
		transform: 'translate3d(0,0,0)',
		width: 500,
		willChange: 'bottom',
	},
	copyButton: {
		marginLeft: 10,
	},
	copyIcon: {
		height: 14,
		width: 14,
	},
	draggableIcon: {
		marginRight: 10,
	},
	flexBetween: {
		...aidaBaseStyles.flexCenter,
		justifyContent: 'space-between',
		width: '100%',
	},
	header: {
		...aidaBaseStyles.flexHorizontalCenter,
		background: brandPrimary,
		borderTopLeftRadius: 4,
		borderTopRightRadius: 4,
		color: white,
		height: 60,
		justifyContent: 'space-between',
		padding: '0 14px',
		position: 'relative',
	},
	icon: {
		height: 17,
		width: 17,
	},
	playerWrapper: {
		padding: '14px 20px',
	},
	subtitle: {
		fontSize: 14,
	},
	title: {
		fontFamily: FontFamilies.bold,
		fontSize: 16,
	},
	titleBar: {
		alignItems: 'center',
		display: 'flex',
	},
	titleContainer: {
		textAlign: 'left',
	},
	speedControl: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 8,
	},
	speedSelect: {
		appearance: 'none',
		background: 'transparent',
		border: '1px solid #ccc',
		borderRadius: 4,
		color: '#333',
		cursor: 'pointer',
		fontSize: 12,
		padding: '4px 8px',
		':hover': {
			borderColor: brandPrimary,
		},
		':focus': {
			borderColor: brandPrimary,
			outline: 'none',
		},
	},
	speedControlSection: {
		display: 'flex',
		justifyContent: 'center',
		padding: '12px 20px 8px',
		borderTop: '1px solid #e0e0e0',
	},
	speedLabel: {
		color: '#666',
		fontSize: 12,
		marginRight: 8,
	},
});
